/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { grayScale, textColor } from 'components/styles';
import Icon from 'components/atoms/Icon';
import FlexBox from 'components/atoms/FlexBox';
import BodyText from 'components/atoms/BodyText';
import Checkbox from 'components/molecules/Checkbox';
import IconLabelButton from 'components/molecules/IconLabelButton';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import Separater from 'components/atoms/Separator';
import DateRangePicker from 'components/molecules/DateRangePicker';
import SelectForm from 'components/molecules/SelectForm';
import { ManagerDataStaffDomain } from 'domain/master/general/managerDataStaff';
import { useManagerEdit } from './hooks';
import { Values } from 'utility/constants';

const styles = {
  undecidedCheckBox: css({
    padding: '6px 8px',
  }),
};

const OrganizationManagerEdit: React.FC<{
  manager: ManagerDataStaffDomain;
  setManager: (manager: ManagerDataStaffDomain) => void;
  deleteManager: () => void;
}> = ({
  manager, deleteManager, setManager,
}) => {
  const {
    isEndDateUndecided,
    toggleEndDateUndecided,
    type,
    changeStartDate,
    changeEndDate,
    changeType,
  } = useManagerEdit(manager, setManager);
  return (
    <React.Fragment>
      <FlexBox>
        <FlexBoxItem>
          <Icon type="organization" color={grayScale.gray100} size="30.5px" />
        </FlexBoxItem>

        <FlexBoxItem grow={1} marginLeft="4px">
          <FlexBox>
            <FlexBoxItem>
              <BodyText>
                {manager.orgName}
              </BodyText>
            </FlexBoxItem>

            <FlexBoxItem marginLeft="auto">
              <IconLabelButton
                iconType="delete"
                text="削除"
                onClick={deleteManager}
                padding=""
              />
            </FlexBoxItem>
          </FlexBox>
          <BodyText size="sm" color={textColor.subText01}>
            {manager.orgCode}
          </BodyText>
        </FlexBoxItem>
      </FlexBox>

      <div css={styles.undecidedCheckBox}>
        <FlexBox>
          <FlexBoxItem basis="40%">
            <SelectForm
              label="区分"
              name="orgCode"
              value={String(type)}
              setValue={(v) => {
                changeType(Number(v));
              }}
              options={Object.values(Values.ManagerType)}
            />
          </FlexBoxItem>

          <FlexBoxItem marginLeft="50px">
            <BodyText>期間</BodyText>
          </FlexBoxItem>

          <FlexBoxItem marginLeft="30px" basis="30%">
            <DateRangePicker
              startDate={manager.startDate}
              setStartDate={changeStartDate}
              endDate={manager.endDate ? manager.endDate : undefined}
              setEndDate={changeEndDate}
              marginLeft="8px"
              endDateDisabled={isEndDateUndecided}
            />
          </FlexBoxItem>

          <FlexBoxItem marginLeft="auto">
            <Checkbox
              id={JSON.stringify(manager)}
              name={JSON.stringify(manager)}
              label="未定"
              value="check"
              checked={isEndDateUndecided}
              onChange={toggleEndDateUndecided}
            />
          </FlexBoxItem>
        </FlexBox>
      </div>

      <Separater margin="12px 0" />
    </React.Fragment>
  );
};

export default OrganizationManagerEdit;
